import React from 'react';
import ProductFocus from './ProductFocus';
import { PageLayout } from '@/components';

const Product: React.FC = () => {
  return (
    <PageLayout>
      <ProductFocus />
    </PageLayout>
  );
}

export default Product;
